import { Configuration, RedirectRequest } from "@azure/msal-browser";
import { getSessionConfig, getMsalCacheConfig } from "./sessionConfig";
import { configService } from "../services/config";

// Obtener configuración de sesión
const sessionConfig = getSessionConfig();
const cacheConfig = getMsalCacheConfig(sessionConfig.strategy);

/**
 * Crea la configuración MSAL usando la configuración cargada desde JSON
 */
export const createMsalConfig = async (): Promise<Configuration> => {
  const authConfig = await configService.getAuthConfig();

  if (!String(authConfig.clientId || "").trim() || !String(authConfig.authority || "").trim()) {
    throw new Error(
      "MSAL requires auth.clientId and auth.authority in public/assets/config/configuration.json (copy from configuration.example.json)."
    );
  }

  return {
    auth: {
      clientId: authConfig.clientId.trim(),
      authority: authConfig.authority.trim(),
      redirectUri: authConfig.redirectUri,
      postLogoutRedirectUri: authConfig.postLogoutRedirectUri,
    },
    cache: cacheConfig,
    system: {
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) {
            return;
          }
          switch (level) {
            case 0:
              console.error(message);
              return;
            case 1:
              console.warn(message);
              return;
            case 2:
              console.info(message);
              return;
            case 3:
              console.debug(message);
              return;
          }
        },
      },
    },
  };
};

export const loginRequest: RedirectRequest = {
  scopes: ["User.Read"],
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

export { sessionConfig };
